import mixpanel from "mixpanel-browser";

import { getParentURL } from "../utils/getParentURL";
import type { AnalyticsActionData, AnalyticsIntent } from "./types";

mixpanel.init(import.meta.env.VITE_MIXPANEL_PROJECT_TOKEN, {
  api_transport: "sendBeacon",
});

class AnalyticsManager {
  private metaData: Record<string, unknown>;

  async track(eventName: string, properties: Record<string, unknown>) {
    mixpanel?.track(eventName, { ...this.metaData, ...properties });
  }

  registerMetaData({
    intent,
    actionData,
    language,
    isEmbedBySDK,
  }: {
    intent: AnalyticsIntent;
    actionData: AnalyticsActionData;
    language: string;
    isEmbedBySDK: boolean;
  }) {
    this.metaData = {
      intent_id: intent.id,
      parent_url: getParentURL(),
      account: (intent as PaymentIntent).account,
      organization: (intent as PaymentIntent).organization,
      language,
      is_live: intent.is_live,
      is_embed_by_sdk: isEmbedBySDK,
      provider_id: (actionData as PaymentActionData).provider_id,
      provider_name: (
        (actionData as PaymentActionData).provider ||
        (actionData as PaymentActionData).provider_name
      )?.toLocaleLowerCase?.(),
      ui_config: {
        form_only: intent.form_only,
        hide_amount_sidebar: intent.hide_amount_sidebar,
        hide_header: intent.hide_header,
        hide_form_header_message: intent.hide_form_header_message,
        hide_loader_message: intent.hide_loader_message,
        hide_retry_button: intent.hide_retry_button,
        hide_try_different_method_button:
          intent.hide_try_different_method_button,
      },
      intent_config: {
        custom_fields: Boolean(
          (actionData as PaymentActionData).transaction?.custom_fields
        ),
        custom_form: Boolean((actionData as PaymentActionData).form_title),
        back_url: Boolean(intent.back_url),
      },
    };
  }
}

export const analytics = new AnalyticsManager();
